import { safeParseJSON } from "./File-parsers/safeParseJSON.js";
import { monolithMoment } from "./date-format";

const hasValue = (value) =>
  value !== null && value !== undefined && value !== "";

const resolveCustomFieldValue = (customField, options = {}) => {
  const { includeTime = false } = options;
  const editorType = customField?.editor_type;
  const rawValue = customField?.value;

  switch (editorType) {
    case "dateBox":
      return hasValue(rawValue)
        ? monolithMoment({ timestamp: rawValue, includeTime })
        : "";
    case "tagBox": {
      if (!hasValue(rawValue)) return "";
      const parsed = safeParseJSON(rawValue) ?? [];
      if (Array.isArray(parsed)) return parsed.join(", ");
      if (parsed != null && typeof parsed === "object")
        return JSON.stringify(parsed);
      return parsed;
    }
    case "textBox":
    case "dropDown":
    default:
      return hasValue(rawValue) ? rawValue : "";
  }
};

export default resolveCustomFieldValue;
